import { CustomerPaymentBehavior } from '@dill/dill-shared';

interface EarlyPayersCardProps {
  customers: CustomerPaymentBehavior[];
}

function EarlyPayersCard({ customers }: EarlyPayersCardProps) {
  if (!customers || customers.length === 0) {
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
          <svg
            className="w-4 h-4 text-blue-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Early Payers</h3>
      </div>
      <div className="flex items-center justify-center h-24 text-gray-400">
        No early payers data available
      </div>
    </div>;
  }

  // Sort by average days to pay (lowest first)
  const sortedCustomers = [...customers].sort((a, b) => a.averageDaysToPay - b.averageDaysToPay);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
            <svg
              className="w-4 h-4 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900">Top 10 Early Payers</h3>
        </div>
        {/* <span className="text-sm text-gray-500">{customers.length} customers</span> */}
      </div>

      <div className="space-y-3  overflow-y-auto">
        {sortedCustomers.slice(0, 10).map((customer) => (
          <div
            key={customer.customerId}
            className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-medium text-sm">
                  {customer.customerName.charAt(0).toUpperCase()}
                </span>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">{customer.customerName}</p>
                <p className="text-xs text-gray-500">
                  ${customer.totalAmount.toLocaleString()} total
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-blue-600">
                {customer.averageDaysToPay.toFixed(0)} days avg
              </p>
              <p className="text-xs text-gray-500">
                {customer.earlyPaymentCount} early / {customer.fullPaymentCount} full
              </p>
            </div>
          </div>
        ))}
        {/* {customers.length > 10 && ( */}
        {/*   <p className="text-center text-xs text-gray-500 py-2"> */}
        {/*     +{customers.length - 10} more customers */}
        {/*   </p> */}
        {/* )} */}
      </div>
    </div>
  );
}

export default EarlyPayersCard;
